export const getIsPosting = state => state.getIn(['powerOfAttorney', 'isPosting']);
export const getIsGeting = state => state.getIn(['powerOfAttorney', 'isGetting']);
export const getErrMsg = state => state.getIn(['powerOfAttorney', 'errMsg']);

export const getAppointorType = state => state.getIn(['powerOfAttorney', 'appointorType']);
export const getTypeId = state => state.getIn(['powerOfAttorney', 'typeId']);
export const getLawer = state => state.getIn(['powerOfAttorney', 'lawer']);
export const getAppointor = state => state.getIn(['powerOfAttorney', 'appointor']);
export const getCompany = state => state.getIn(['powerOfAttorney', 'company']);